import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";

import { selectCurrentServiceCronJobs } from "../deployment";

export const useCurrentServiceCronJobs = () => {
  return useSelectorWithUrlParams(selectCurrentServiceCronJobs);
};
